export enum SearchMinimumDataFilterValue {
  TELESCOPES = "t",
  CAMERAS = "c",
  ACQUISITION_DETAILS = "a",
  ASTROMETRY = "s"
}
